import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.5 16C6.5 15.1716 7.17157 14.5 8 14.5C8.82843 14.5 9.5 15.1716 9.5 16C9.5 16.8284 8.82843 17.5 8 17.5C7.17157 17.5 6.5 16.8284 6.5 16Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.4142 5.00015L20.9999 6.41437L19.9999 5.41437L19.4142 6.00015L19.9142 6.50015L18.4999 7.91437L17.9999 7.41436L17.1715 8.24284C17.6947 9.03311 18 9.98149 18 11.0002C18 13.0559 16.7601 14.8202 14.9881 15.589C14.996 15.7251 15 15.8622 15 16.0002C15 19.8661 11.866 23.0002 8 23.0002C4.13401 23.0002 1 19.8661 1 16.0002C1 12.1342 4.13401 9.00015 8 9.00015C8.13795 9.00015 8.27505 9.00416 8.41119 9.01206C9.17998 7.24001 10.9443 6.00015 13 6.00015C14.0186 6.00015 14.967 6.30548 15.7572 6.82864L16.5857 6.00015L16.0857 5.50015L17.4999 4.08594L17.9999 4.58594L18.5857 4.00015L17.5857 3.00015L18.9999 1.58594L22.4142 5.00015ZM8 12.5C6.067 12.5 4.5 14.067 4.5 16C4.5 17.933 6.067 19.5 8 19.5C9.933 19.5 11.5 17.933 11.5 16C11.5 14.067 9.933 12.5 8 12.5Z"}}]};

const GuitarFilled = Vue.extend<IconProps>({
  name: 'GuitarFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'guitar-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GuitarFilled;
